export const toFrontendPhone = (phone) => {
  if (typeof phone === "object" && phone.phone_number) {
    return `+7 (${phone.area_code}) ${phone.phone_number.slice(0, 3)} ${phone.phone_number.slice(3)}`;
  }
}
